import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { EmptyStateRow, TableLoader } from 'features/command-center/components';
import { useStyles } from 'features/command-center/components/shared';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import { UIStatus } from 'UI/constants/status';

import { formatTransactionByRecruiterResponse } from '../../fallOffsBoard.utils';

export const TransactionsByRecruiter = ({ columns, selectedRecruiterId, queryParams }) => {
  const classes = useStyles();

  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.fallOffTransactionsByRecruiter.replace(
    ':id',
    selectedRecruiterId
  )}?${queryParams}`;

  const { state } = useFetchWithStatusV2({
    endpoint,
    apiInstance: SECONDARY_API_CLIENT
  });

  const formattedData = formatTransactionByRecruiterResponse(state?.results);

  if (state.status === UIStatus.Loading) return <TableLoader colSpan={columns.length} />;

  if (!formattedData) return <EmptyStateRow colSpan={columns.length} />;

  return formattedData.map(row => (
    <TableRow key={row.transactionName} hover>
      <TableCell />

      {columns.map(col => {
        if (col.options.display !== true) return null;

        return (
          <TableCell key={col.name}>
            <span className={classes.regularWeightRow}>
              {col?.options?.customBodyRender
                ? col.options.customBodyRender(row[col.name])
                : row[col.name]}
            </span>
          </TableCell>
        );
      })}
    </TableRow>
  ));
};
